<div class="header">
  <div class="header__section--left">
    <i class="pi pi-bars" (click)="toggleSidebar()" tabindex="0"></i>
  </div>
  <div class="header__section--right">
    <p-button
      label="Create request"
      i18n-label="@@header.button.create_request"
      icon="pi pi-plus"
      severity="success"
      size="small"
      (onClick)="showRequestDialog()" />
    <carehub-language-selector></carehub-language-selector>

    @if (isSuperAdmin$ | async) {
      <i
        tabindex="0"
        class="pi pi-comment"
        (click)="showCareAiDialog()"
        pTooltip="CareAI"
        tooltipPosition="bottom"></i>
    }
    <i
      class="pi pi-bell icon-badge__status"
      [ngClass]="unreadNotificationsCount() ? '' : ' icon-badge__status--empty'"
      pBadge
      [value]="unreadNotificationsCount()"
      (click)="notifications().length && notificationMenu.toggle($event)"
      tabindex="0"></i>
    <div class="profile-switcher">
      <i class="pi pi-user" #userMenuTrigger (click)="userMenu.toggle($event)" tabindex="0"></i>
      {{ (activeAccount$ | async)?.fullName ?? '' }}
    </div>
  </div>
</div>

<p-menu #notificationMenu [model]="notificationMenuItems()" [popup]="true">
  <ng-template #submenuheader let-item>
    <span class="menu__header">{{ item.label }}</span>
  </ng-template>
  <ng-template #item let-item>
    <a
      [href]="item.url"
      class="menu__item"
      [ngClass]="{ 'menu__item--unread': !isRead(item) }"
      (click)="openNotification(item.id)">
      <span>{{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>

<p-menu #userMenu [model]="(userMenuItems$ | async)!" [popup]="true">
  <ng-template #submenuheader let-item>
    <span class="menu__header">{{ item.label }}</span>
  </ng-template>
</p-menu>

<carehub-request-creation [(visible)]="isRequestDialogVisible"></carehub-request-creation>

<carehub-care-ai [(visible)]="isCareAiDialogVisible"></carehub-care-ai>
